/* eslint-disable no-magic-numbers */
export const MAX_Y = 20037471.20513706;
export const TMS_MIN_Y = -20037471.20513706;
export const R = 6378137; // Earth's radius in meters (used in Web Mercator)

export function latLonToWebMercator(
  lat: number,
  lon: number
): { x: number; y: number } {
  const R = 6378137;
  const x = (R * lon * Math.PI) / 180;
  const y = R * Math.log(Math.tan(Math.PI / 4 + (lat * Math.PI) / 360));
  return { x, y };
}

/*
 * Converts Web Mercator coordinates to latitude and longitude.
 * @param x The x coordinate in Web Mercator.
 * @param y The y coordinate in Web Mercator.
 * @returns An object with the latitude and longitude.
 */
export function webMercatorToLatLon(
  x: number,
  y: number
): { lat: number; lon: number } {
  const lon = webMercatorXToLon(x);
  const lat = webMercatorToLatTMS(y);

  return { lat, lon };
}

export function webMercatorXToLon(x: number): number {
  return (x / R) * (180 / Math.PI);
}

export function webMercatorToLatTMS(y: number): number {
  const flippedY = TMS_MIN_Y + y; // Flip the Y-axis for TMS
  return Math.atan(Math.sinh(flippedY / R)) * (180 / Math.PI);
}

export function webMercatorYToLat(y: number): number {
  return (Math.atan(Math.exp(-y / R)) * 2 - Math.PI / 2) * (180 / Math.PI);
}
